
















import { DashboardService } from "@/services/dashboard.service";
import GlobalMixin from "@/shared/mixins/globalMixin";
import { Component, Mixins, Prop, Watch } from "vue-property-decorator";

@Component({
  
})
export default class GratisExpiradosCard extends Mixins(GlobalMixin) {
  totalGratisExpirados: number | null = null;
  loadingEventos = false;

  @Prop() readonly date!: string | null;

  mounted() {
    this.onChangeDate();
  }

  @Watch("date")
  onChangeDate() {
    this.CarregarGratisExpirados();
  }

  async CarregarGratisExpirados() {
    this.loadingEventos = true;
    if (this.date) {
      this.totalGratisExpirados = await DashboardService.GratisExpirados(this.date).finally(
        () => (this.loadingEventos = false)
      );
    }
  }

}
